import { API_ERROR_MESSAGE, NO_RESULTS_FOUND } from '../../utils/Constants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { ProductIds, ReportTypes } from '../apiConstants'
import { makeApiCall } from '../APIService'

interface HandleWorldComplianceDownloadReportProps {
  reportId: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
}

export const handleWorldComplianceDownloadReport = (
  props: HandleWorldComplianceDownloadReportProps,
): void => {
  const { reportId, setShowProgress, setIsError, setErrorMessage } = props
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId,
      reportType: ReportTypes.WorldComplianceReport.reportTypeId,
    }),
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')

  fetch(`${getAPIUrl()}/WorldCompliance/download-report`, requestOptions)
    .then((res: Response) => {
      return res.blob()
    })
    .then((blob: Blob) => {
      setShowProgress(false)
      const href = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'WorldCompliance.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
      return Promise.reject({ Error: 'Something Went Wrong', error })
    })
}
interface HandleWorldComplianceLoadReportProps {
  sanctionScreeningCompany: {
    enquiryId?: string
    enquiryResultId?: string
    registrationNo?: string
  }
  reference: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setReportId: (value: string) => void
  downloadReport: (reportId?: string) => void
}
export const handleWorldComplianceLoadReport = ({
  sanctionScreeningCompany,
  reference,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setReportId,
  downloadReport,
}: HandleWorldComplianceLoadReportProps): void => {
  const API_URL = `${getAPIUrl()}/WorldCompliance/load-report`
  const body = {
    reference,
    purpose: '',
    registrationId: sanctionScreeningCompany?.registrationNo,
    enquiryID: sanctionScreeningCompany?.enquiryId,
    enquiryResultID: sanctionScreeningCompany?.enquiryResultId,
    productId: ProductIds.WorldComplianceReport.productId,
    reportType: ReportTypes.WorldComplianceReport.reportTypeId,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response: { statusCode: number; data: { reportId: string } }) => {
      if (response.statusCode !== 200) {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      } else {
        downloadReport(response.data.reportId)
        setReportId(response.data.reportId)
        setShowProgress(false)
      }
    },
    (error: { response: { data: { message: string } } }) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    null,
    false,
  )
}

interface HandleWorldComplianceProps {
  businessName: string
  reference: string
  country: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setSanctionScreeningCompanies: (value: []) => void
}

export const handleWorldComplianceSearchCompany = ({
  reference,
  businessName,
  country,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setSanctionScreeningCompanies,
}: HandleWorldComplianceProps): void => {
  const API_URL = `${getAPIUrl()}/WorldCompliance/search-company`
  const body = {
    businessName,
    reference,
    country,
    productId: ProductIds.WorldComplianceReport.productId,
    reportType: ReportTypes.WorldComplianceReport.reportTypeId,
    soleProprietorId: '',
    vatNumber: '',
    purpose: '',
    registrationNumber: '',
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response: { statusCode: number; data: [] }) => {
      if (response.data.length === 0) {
        setShowProgress(false)
        let searchCriteria = ''
        if (businessName) searchCriteria += `Business Name: ${businessName} `
        if (country) searchCriteria += `Country: ${country} `
        alert(`No results found for: ${searchCriteria}`)
      } else {
        setShowProgress(false)
        setSanctionScreeningCompanies(response.data)
      }
    },
    (error: { response: { data: { message: string } } }) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    null,
    false,
  )
}
